import { ReactNode } from "react";

import { type VariantProps, cva } from "class-variance-authority";

import { cn } from "@/common/utils/css.utils";

const productBadge = cva(
  "rounded-full px-2 py-0.5 font-body text-sm font-semibold",
  {
    variants: {
      tone: {
        sold: "bg-brand-500 text-white",
        discount: "bg-attention-500 text-white",
        owner: "bg-flavour-50 text-brand-500",
        reserved: "bg-grey-600 text-white",
        reservedMine: "bg-curious-800 text-white",
      },
    },
  }
);

type ProductBadgeProps = VariantProps<typeof productBadge> & {
  children: ReactNode;
  className?: string;
};

/** The overlay badge on a product image (Sold, -20%, …), shared by the product card and the PDP. */
export const ProductBadge = ({
  tone,
  className,
  children,
}: ProductBadgeProps) => (
  <span className={cn(productBadge({ tone }), className)}>{children}</span>
);
